import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import {
  IInvestmentPassportsItem,
  TInvestmentPassportsDraftItem,
} from 'store/slices/investmentPassports/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  loadInvestmentPassportsItem,
  saveInvestmentPassportsItem,
  saveInvestmentPassportsItemAsDraft,
} from 'store/slices/investmentPassports/actions';
import { LangEnum } from 'constants/lang';

import { InvestmentPassportsForm } from './components/InvestmentPassportsForm';
import { mapValuesToForm } from './components/formUtils';

export const AddTranslation = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.investmentPassports);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    dispatch(loadInvestmentPassportsItem(id));
  }, []);

  const onFinish = (values: IInvestmentPassportsItem) => {
    setIsLoading(true);
    dispatch(saveInvestmentPassportsItem(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/investmentPassports');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: TInvestmentPassportsDraftItem) => {
    setIsLoading(true);
    dispatch(saveInvestmentPassportsItemAsDraft(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/investmentPassports');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/investmentPassports');
  };

  // catalog values depends on lang
  const preparedValues = {
    ...item,
    lang: LangEnum.en,
  };

  return (
    <MainLayout pageTitle='Создание'>
      {item?.id && String(item?.id) === id ? (
        <InvestmentPassportsForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft
          isLoading={isLoading}
          initialValues={mapValuesToForm(preparedValues)}
        />
      ) : null}
    </MainLayout>
  );
};
